<template>
  <div class="train-detail-container">
    <!-- <van-nav-bar title="" left-arrow left-text="返回" @click-left="returnMy">
    </van-nav-bar> -->
    <van-cell class="container-top">
      <div class="title">{{ trainName }}</div>
      <div class="numall">￥{{ num1 }}/人次</div>
    </van-cell>

    <van-row class="trainRegNumber" type="flex" justify="center">
      <van-col span="8" offset="2"><span>选择报名人数：</span> </van-col>
      <van-col span="10" offset="4">
        <van-stepper
          v-model="trainRegNumber"
          disable-input
          integer
          @plus="changeTrainRegNumber(1)"
          @minus="changeTrainRegNumber(2)"
          class="trainRegNumber-nub"
        />
      </van-col>
    </van-row>
    <van-form
      validate-first
      scroll-to-error
      :show-error="false"
      @submit="addTrainReg"
      label-width="5rem"
    >
      <h3 class="cellSty">发票信息</h3>

      <van-field
        readonly
        clickable
        required
        name="picker"
        :value="value"
        label="发票抬头"
        placeholder="点击选择发票抬头"
        @click="tianjia"
        :rules="[{ required: true, message: '请选择发票' }]"
      />
      <van-action-sheet
        v-model="showPicker"
        description="选择发票"
        :style="{ height: '67%' }"
        cancel-text="新增发票"
        @cancel="onCancel()"
      >
        <van-radio-group v-model="result">
          <div class="alllist" v-for="item2 in columns" :key="item2.id">
            <div class="content">
              <van-radio @click="guanbi" :name="item2.id"></van-radio>
            </div>
            <div class="content2">
              <div>发票抬头 ：{{ item2.companyName }}</div>
              <div>单位税号：{{ item2.companyTax }}</div>
              <div>邮箱：{{ item2.taxMail }}</div>
              <div>手机：{{ item2.taxPhone }}</div>
              <div>注册地址：{{ item2.taxAddress }}</div>
              <div>注册电话：{{ item2.taxTe }}</div>
              <div>开户银行：{{ item2.taxBank }}</div>
              <div>银行账号：{{ item2.taxAccount }}</div>
            </div>
          </div>
        </van-radio-group>
        <!-- <div>
          <van-button round type="info">新增发票</van-button>
        </div> -->
      </van-action-sheet>
      <h3 class="cellSty">学员信息</h3>
      <van-list :finished="true">
        <van-cell v-for="(item, index) in list" :key="index" class="addlist">
          <div class="cell-all">
            <div class="cellTop">
              <p>学员{{ index + 1 }}</p>
            </div>
            <div class="cellMiddle">
              <van-cell-group>
                <van-field
                  v-model="item.regUserName"
                  required
                  label="姓名"
                  maxlength="10"
                  placeholder="请输入"
                  :rules="[{ required: true, message: '请输入姓名' }]"
                />
                
                <van-field
                  v-model="item.regUserPhone"
                  required
                  label="手机号"
                  placeholder="请输入"
                  :rules="[
                    { required: true, message: '请输入手机号' },
                    { validator: validatorPhone, message: '手机号格式有误' },
                  ]"
                />
                <van-field
                  v-model="item.regEmail"
                  label="邮箱"
                  required
                  placeholder="请输入"
                  :rules="[
                    { required: true, message: '请输入邮箱' },
                    { validator: validatorEmail, message: '邮箱格式有误' },
                  ]"
                />
                <van-field
                  v-model="item.regUserCard"
                  label="身份证号"
                  required
                  placeholder="请输入"
                  :rules="[
                    { required: true, message: '请输入身份证号' },
                    { validator: validatorCard, message: '身份证号格式有误' },
                  ]"
                />
               
              </van-cell-group>
            </div>
          </div>
        </van-cell>
      </van-list>
      <van-row class="bottomRow" gutter="20">
        <van-col  style="line-height: 4rem" span="8" offset="1"
          >合计：<span class="word">￥{{ num2 }}</span></van-col
        >
        <van-col class="text" span="12">
          <van-button
            style="width: 100%"
            type="info"
            :disabled='disabled'
            round
            block
            native-type="submit"
            >提交订单</van-button
          >
        </van-col>
      </van-row>
    </van-form>
  </div>
</template>

<script>
import {
  ActionSheet,
  Checkbox,
  checkboxGroup,
  Form,
  Button,
  Cell,
  Popup,
  Picker,
  Stepper,
  Col,
  Row,
  List,
  Field,
  CellGroup,
  NavBar,
  RadioGroup,
  Radio,
} from "vant";
import api from "@/api";

export default {
  components: {
    [ActionSheet.name]: ActionSheet,
    [Checkbox.name]: Checkbox,
    [checkboxGroup.name]: checkboxGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    [Col.name]: Col,
    [Row.name]: Row,
    [Form.name]: Form,
    [Field.name]: Field,
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },

  data() {
    return {
      faiao: "",
      num1: 0,
      num2: 0,
      trainId: "",
      trainName: "",
      trainRegNumber: 1,
      workOrderTypePicker: false,
      value: "",
      result: "",
      disabled:false,
      goodsOrderId:'',
      invoiceId: null,
      checked: false,
      columns: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
      showPicker: false,
      list: [
        {
          regUserName: "",

          regUserPhone: "",
          regEmail:"",
        },
      ],
    };
  },
  mounted() {
    this.trainId = this.$route.query.trainId;
    this.num1 = parseFloat(this.$route.query.trainCost);
    this.num2 = parseFloat(this.$route.query.trainCost);
    this.trainName = this.$route.query.trainName;
    this.fapiaolist();
  },
  methods: {
    onCancel() {
      this.$router.push({
        name: "invoiceadd",
        params: {
          nameorder: "add",
        },
      });
    },
    fapiaolist() {
      api.train.invoicegetList().then((res) => {
        if (res.code == 0) {
          this.columns = res.data.map((item) => {
            return { ...item, shayebushi: false };
          });
        }
      });
    },
    tianjia() {
      this.showPicker = true;
    },
    guanbi() {
      this.columns.forEach((item) => {
        if (this.result == item.id) {
          this.value = `${item.companyName}`;
          this.invoiceId = item.id;
          this.showPicker = false;
        }
      });
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },

    returnMy() {
      this.$router.replace({
        path: "/trainDetail",
      });
    },
    changeTrainRegNumber(type) {
      if (type == 1) {
        this.num2 += this.num1;
        this.list.push({
          regUserName: "",

          regUserPhone: "",
          regEmail:"",
        });
      } else {
        this.num2 -= this.num1;
        this.list.splice(this.trainRegNumber - 1, this.trainRegNumber);
      }
    },
    validatorCard(val) {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(val);
    },
    validatorPhone(val) {
      let reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      return reg.test(val);
    },
    validatorEmail(val) {
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      return reg.test(val);
    },
    addTrainReg() {
      
      let arr = this.list.map((item) => {
        return {
          ...item,
          trainId: this.$route.query.trainId,
          trainCode: this.$route.query.trainCode,
          trainName: this.$route.query.trainName,
          trainAmount: this.$route.query.trainCost,
        };
      });
     
      const param = {
        invoiceId: this.invoiceId,
        trainRegEntity: arr,
      };
      console.log(this.goodsOrderId,"id")
      if(this.goodsOrderId == '' || this.goodsOrderId == undefined){
         this.disabled = true
         // 新增接口调用
      api.train.getTrainadd(param).then((res) => {
        this.disabled = false
        if (res.code != undefined && res.code === 0 ) {
          this.disabled = true
          this.goodsOrderId =  res.goodsOrderId
          
          console.log('1')
          let payParam = {
            goodsOrderId: res.goodsOrderId,
          };
          
          api.train.wxPaywebPay(payParam).then((res2) => {
            let jsonStr = JSON.parse(res2.jsonStr);
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr)
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr)
                );
              }
            } else {
              this.onBridgeReady(jsonStr);
            }
          });
        } else {
          
          this.$toast.fail({
            message: "支付失败",
          });
          
        }
      });
      
      }else{
        this.disabled = true
         let payParam = {
            goodsOrderId: this.goodsOrderId,
          };
        console.log('2')
          api.train.wxPaywebPay(payParam).then((res2) => {
            let jsonStr = JSON.parse(res2.jsonStr);
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr)
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady(jsonStr)
                );
              }
            } else {
              this.onBridgeReady(jsonStr);
            }
          });
      }
     
    },
    
    onBridgeReady(json) {
      
      var vm = this
      WeixinJSBridge.invoke("getBrandWCPayRequest", json, function (res) {
      //   // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
      //      const param = {
      //    goodsOrderId: location.getItem('key')
      //   }
      // api.train.getTrainInfo(param).then(res => {
      //   if(res.code == 0){
      //      let datalist = res.payGoodsOrderEntity.status
      //     if(datalist == 1){
      //     
      //     location.removeItem('key')
      //     }else{
      //        this.$toast.fail({
      //       message: "支付失败",
      //     });
      //     }
      //   }

      // })
     
      
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          vm.$toast.success({
            message: "支付成功",
          })
          // window.location.href =  '/myPaly'
           window.location.href = "https://m.cnpcbidding.com/myPaly";
        } else {
          vm.disabled = false
          vm.$toast.fail({
            message: "支付失败",
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
</style>
<style lang="less" scoped>
.van-action-sheet__gap{
  // height: 0;
  background-color: #fff;
}
.train-detail-container {
  background: #f8f8f8;
  .container-top {
    background: #fff;
  }
  .title {
    font-size: 5.333332vw;
    color: #222;
    font-weight: 800;
    
  }
  .numall {
    margin-top: 3.5999991vw;
    font-size: 4.2666656vw;
    color: #FAA105 ;
  }
}
.alllist {
  overflow: auto;
  display: flex;
  background: #f8f8f8;
  margin: 0.6rem;
  padding: 0.6rem;
  margin-bottom: 0.8rem;
  .content {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #f0f0f0;
  }
  .content2 {
    margin-left: 1rem;
    font-size: 0.8rem;
    flex: 5;
  }
}
/deep/.van-col--offset-2{
  margin-left: 0.1rem;
}
.trainRegNumber {
  // margin-top: 1rem;
  color: #222;
  height: 3.5rem;
  line-height: 3.5rem;
  background: #fff;
  span {
    color: #222;
    font-size: 4.2666656vw;
    
  }
  .van-stepper {
    margin-left: 2.5rem;
  }
}
.cell-all {
  display: flex;
  flex-direction: column;
}
.cellTop {
  color: #888888;
  font-size: 0.75rem;
  // float: left;
  // width: 3rem;
  // height: 2rem;
  // line-height: 13rem;
}
.cellMiddle {
  border-radius: 20px;
  // background: #f8f8f8;
  // background: red;
  // float: right;
  // position: relative;
  /deep/.van-cell-group {
    border-radius: 0.7rem;
    // background: red;
  }
}
.cellRight {
  position: absolute;
  right: 0rem;
  bottom: 0rem;
}
.cellSty {
  color: #222;
  font-size: 0.9rem;
  margin-top: 1rem;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 2.66667vw 4.26667vw;
  overflow: hidden;
  color: #323233;
  background-color: #fff;
}
.bottomRow {
  height: 24.666605vw;
  // margin-bottom: 0rem;
  width: 100%;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/.van-col--offset-1 {
    margin-left: 0.2rem;
    font-size:4.1999992vw ;
  }
  .text{
    margin-left: 2rem;
  }
  .word{
    color: rgba(244, 41, 13, 1);
    font-size:4.7999988vw;
  }
}

/deep/.van-form {
  height: 40rem;
  overflow-y: auto;
}
/deep/.van-action-sheet__cancel {
  color: #fff;
  background-color: #1986fa;
  border-radius: 2rem;
  width: 80%;
  margin: auto;
  cursor:pointer;
}
/deep/.van-action-sheet__description {
  color: #000;
  font-size: 4.7333vw;
}
.addlist {
  margin-bottom: 0.6rem;
}
</style>
